export const uniqueName = (gruppen: Array<string>) => (neueGruppe) =>
  !gruppen.includes(neueGruppe);

export const hasData = (data: Array<any>) => (_: string | undefined) => {
  return data.length > 0;
};
